import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  uras: [],
  uraSelecionada: {},
  uraUse: {},
  rotasDisponiveis: [],
  audios: [],
  gruposDeRotas: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
